namespace $ {
	export class $mol_check_icon extends $mol_check {
	}
	
}

